import { render, staticRenderFns } from "./ConsensusIcon.vue?vue&type=template&id=cbdbabce&scoped=true&"
import script from "./ConsensusIcon.vue?vue&type=script&lang=ts&"
export * from "./ConsensusIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ConsensusIcon.vue?vue&type=style&index=0&id=cbdbabce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdbabce",
  null
  
)

export default component.exports